import { AuditoriaBeanM } from './auditoria_bean';
import { ServiceCredencialesM } from './service-credenciales-bean';


export class MaeCorreoE {
  c_correo:Number;
  x_asunto:String;
  x_mensaje:String;
  x_parametros:String;
  auditoriaBeanM:AuditoriaBeanM;
  serviceCredencialesM:ServiceCredencialesM;
  }
  export class MaeCorreoM {
    c_usuario:Number;
    x_nombres:String;
    x_destinatario:String;
    x_organo:String;
    x_tipo_organo:String;
    x_asunto:String;
    x_mensaje:String;
    b_enviar:Boolean;
    }
